import { render, staticRenderFns } from "./orders-list.vue?vue&type=template&id=7b5559c8&scoped=true&"
import script from "./orders-list.vue?vue&type=script&lang=js&"
export * from "./orders-list.vue?vue&type=script&lang=js&"
import style0 from "./orders-list.vue?vue&type=style&index=0&id=7b5559c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5559c8",
  null
  
)

component.options.__file = "orders-list.vue"
export default component.exports